export * from './UserPasswordPageLazy';
